export default class Deposito  {
	constructor() {
		const dep = JSON.parse(localStorage.getItem("olma_deposito"));
		this._id = dep._id;
		this.codice = dep.codice;
		this.descrizione = dep.descrizione;
	}
}